import { writable } from 'svelte/store';

export const availableBets = writable([]);
export const selectedBetIndex = writable(null);
export const selectedBetAmount = writable(0);
export const popularBetIndex = writable(null);

export const initBetsValues = betConfigs => {
    const betLimits: [number] = betConfigs.bet_limits;
    const defaultBet: number = betConfigs.default_bet;
    const defaultBetIndex: number = betLimits.findIndex((betValue: number) => betValue === defaultBet);
    const betPopularIndex: number = betLimits.findIndex((betValue: number) => betValue === betConfigs.popular_bet);

    availableBets.set(betLimits);
    selectedBetAmount.set(defaultBet);
    selectedBetIndex.set(defaultBetIndex);
    popularBetIndex.set(betPopularIndex);
};
